// Утилиты для работы с датами (в формате YYYY-MM-DD)
export const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

export const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

// new Date -> 'YYYY-MM-DD' (локальное время, без сдвига часового пояса)
export function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// 'YYYY-MM-DD' -> new Date (локальная полночь)
export function fromISODate(iso) {
  if (!iso) return new Date();
  const parts = iso.split('-').map(Number);
  const y = parts[0];
  const m = parts[1] ? parts[1] - 1 : 0;
  const d = parts[2] || 1;
  return new Date(y, m, d);
}

// Сегодняшняя дата в формате YYYY-MM-DD
export function todayISO() {
  return toISODate(new Date());
}

// Форматируем дату для отображения: 25 янв 1998
const SHORT_MONTHS = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

export function formatDate(input) {
  if (!input) return '';
  let d;
  if (typeof input === 'string') {
    // ожидаем YYYY-MM-DD
    d = fromISODate(input);
  } else if (input instanceof Date) {
    d = input;
  } else {
    return String(input);
  }
  const day = d.getDate();
  const month = SHORT_MONTHS[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
}

// Форматируем сумму: 1 234,56 ₽ (целые без копеек по умолчанию)
export function formatMoney(value) {
  if (value === null || value === undefined) return '';
  const num = Number(value) || 0;
  // Формат с разделителем тысяч и без дробной части
  return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ₽';
}

// Форматируем сумму с копейками (2 знака после запятой), поддерживает отрицательные значения
export function formatMoneyPrecise(value) {
  if (value === null || value === undefined) return '';
  const num = Number(value) || 0;
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ₽';
}
